export default __webpack_public_path__ + "static/media/profileTabIcon.a4ff5934.svg";